import { 
  getCommodity,
} from "@/api/payment2";

export default {
  namespaced: true,
  state: {
    commodity: null,
    id: null,
    combinationOperatorSite: 1, // 组合 operator 数量
    combinationDriverSite: 2, // 组合driver数量
    combinationPrice: 9900, // 组合价格
    operatorSiteUnitPrice: 3000, // operator单价
    driverSiteUnitPrice: 2500, // driver单价
    cycleRate: 0.1, // 折扣率
    discount: 1000, // 折扣价
    strikethroughPrice: 11000, // 划线价
    plan: [
      {
        billing: 1,
        discount: 0,
        showPlan: "Monthly Plan"
      },
      {
        billing: 6,
        discount: 0.1,
        showPlan: "6 Month Plan"
      },
      {
        billing: 12,
        discount: 0.17,
        showPlan: "12 Month Plan"
      }
    ],
    operatorNum: 0,
    driverNum: 0,
    billing: 1,
    total: 0, // 绑卡支付使用 - 包括折扣的总价
    remainderCount: 0, // 绑卡支付使用 - 新增seat的总价
    paymentNext: false,
  },
  mutations: {
    SET_COMMODITY(state, payload) {
      Object.keys(payload).forEach(key => {
        state[key] = payload[key] || 0;
      });
      state.commodity = payload;
    },
    SET_OPERATORNUM(state, payload) {
      state.operatorNum = payload;
    },
    SET_DRIVERNUM(state, payload) {
      state.driverNum = payload;
    },
    SET_BILLING(state, payload) {
      state.billing = payload;
      state.cycleRate = state.plan.find(item => item.billing === payload).discount;
    },
    SET_PAYMENTNEXT(state, payload) {
      state.paymentNext = payload;
    },
    SET_TOTAL(state, payload) {
      state.total = payload;
    },
    SET_REMAINDERCOUNT(state, payload) {
      state.remainderCount = payload;
    },
  },
  actions: {
    async getCommodity({ state, commit, rootState }) {
      if (state.commodity) return;
      await getCommodity().then((res) => {
        const data = res.data;
        commit("SET_COMMODITY", data);
        const minDriverNum = (rootState.paymentv2.bills.driverSite || 0) >= (data.combinationDriverSite || 0) ? rootState.paymentv2.bills.driverSite : data.combinationDriverSite
        const minOperNum = (rootState.paymentv2.bills.operatorSite || 0) >= (data.combinationOperatorSite || 0) ? rootState.paymentv2.bills.operatorSite : data.combinationOperatorSite
        commit("SET_DRIVERNUM", minDriverNum || state.combinationDriverSite);
        commit("SET_OPERATORNUM", minOperNum || state.combinationOperatorSite);
      }).catch((error) => {
        Promise.reject(error);
      })
    },
    reselect({ state, commit, rootState }) {
      if (state.paymentNext) return;
      if (rootState.paymentv2.bills.paymentCycle) {
        commit("SET_OPERATORNUM", rootState.paymentv2.bills.operatorSite);
        commit("SET_DRIVERNUM", rootState.paymentv2.bills.driverSite);
        commit("SET_BILLING", rootState.paymentv2.bills.paymentCycle);
      } else {
        commit("SET_OPERATORNUM", state.combinationOperatorSite);
        commit("SET_DRIVERNUM", state.combinationDriverSite);
        commit("SET_BILLING", 1);
      }
      commit("SET_TOTAL", 0);
      commit("SET_REMAINDERCOUNT", 0);
    }
  },
  getters: {
    getDistanceMonth(state, getters, rootState){
      if (rootState.paymentv2.bills && rootState.paymentv2.bills.card.nextBillDate) {
        let fDate = new Date(rootState.paymentv2.bills.card.nextBillDate);
        let fyear = fDate.getFullYear()
        let fmonth = fDate.getMonth() + 1
        let fday = fDate.getDate()

        let date = new Date()
        let year = date.getFullYear()
        let month = date.getMonth()+1
        let day = date.getDate()
      
        let yearToMonth = (fyear - year) * 12
        let monthToMonth = fmonth - month
        let dateToMonth = 0
        if(fday >= day){
          dateToMonth = 0
        }else{
          dateToMonth = -1
        }
        return yearToMonth + monthToMonth + dateToMonth + 1
      }
      return 0;
    },
  }
}
